import React from "react";

const NotFound = () => {
  return (
    <div
      className="align-items-center my-5 d-flex justify-content-center align-items-center"
      div
      style={{ height: "70vh" }}
    >
      <div>
        <p className="text-dark text-center bg-light display-3">
          متاسفانه صفحه مورد نظر شما یافت نشد !
        </p>
        <br />
        <p className="text-dark text-center bg-light display-6">
          لطفا در انتخاب کلیدواژه دقت نمایید
        </p>
      </div>
    </div>
  );
};

export default NotFound;
